var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55703 0C4.52603 0 0.457031 4.069 0.457031 9.1C0.457031 15.925 9.55703 26 9.55703 26C9.55703 26 18.657 15.925 18.657 9.1C18.657 4.069 14.588 0 9.55703 0ZM3.05703 9.1C3.05703 5.512 5.96903 2.6 9.55703 2.6C13.145 2.6 16.057 5.512 16.057 9.1C16.057 12.844 12.313 18.447 9.55703 21.944C6.85303 18.473 3.05703 12.805 3.05703 9.1Z",
    fill: "#DB1F51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55664 12.3498C11.3516 12.3498 12.8066 10.8947 12.8066 9.09979C12.8066 7.30487 11.3516 5.84979 9.55664 5.84979C7.76172 5.84979 6.30664 7.30487 6.30664 9.09979C6.30664 10.8947 7.76172 12.3498 9.55664 12.3498Z",
    fill: "#DB1F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c4050de0e270f10295150ef74abe47b0.svg";
export { ForwardRef as ReactComponent };